import { render, staticRenderFns } from "./HomeM.vue?vue&type=template&id=85b2e6d0&scoped=true&"
import script from "./HomeM.vue?vue&type=script&lang=js&"
export * from "./HomeM.vue?vue&type=script&lang=js&"
import style0 from "./HomeM.vue?vue&type=style&index=0&id=85b2e6d0&scoped=true&lang=css&"
import style1 from "./HomeM.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b2e6d0",
  null
  
)

export default component.exports